import { FC } from 'react'
import { Outlet } from 'react-router-dom'
import Header from '@/components/header/Header'

import  "./OutletWrapper.css";

const OutletWrapper: FC = () => {
    return (
        <>
            <div className="app-layout">
                <Header />

                <div className="app-layout-container">
                    {/* <SideNav /> */}
                    <div className="main-content-wrapper">
                        <Outlet />
                    </div>
                </div>
            </div>
        </>
    )
}

export default OutletWrapper